var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginPageLeftSideLayer2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "25.82rem",
    viewBox: "0 0 851.383 541.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12046",
    "data-name": "Group 12046",
    transform: "translate(-1303.925 -251.413)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M739.954,1204.351a176.355,176.355,0,1,0-88.884,124.227,177.481,177.481,0,0,0,31.369-22.073c1.577,1.215,3.186,2.431,4.8,3.614,23.781,17.933,47.628,36.164,73.052,51.766.1.066.23.131.329.2a273.943,273.943,0,0,1-26.7,24.207,269.426,269.426,0,0,1-167.685,58.24c-149.455,0-270.628-121.141-270.628-270.595,0-149.488,121.173-270.629,270.628-270.629S836.82,1024.447,836.82,1173.935a272.349,272.349,0,0,1-6.733,60.306C798.718,1225.536,768.3,1215.059,739.954,1204.351Z",
    transform: "translate(1008.327 -651.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12043",
    "data-name": "Group 12043",
    transform: "translate(1443.165 540.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M579.96,1033.874c-165.067-67.655-241.972,1.514-241.972,1.514,110.6-30.972,181.182,19.833,252.4,73.509,23.775,17.918,47.625,36.148,73.059,51.771,40.192,24.693,84.342,42.858,138.428,42.9,222.03.143,248.256-212.18,248.256-212.18-108.987,174.264-331.107,99.494-470.171,42.491",
    transform: "translate(-337.988 -991.383)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12044",
    "data-name": "Group 12044",
    transform: "translate(1543.399 359.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M374.736,967.255c-5.883,6.468-10.432,16.854,0,28.239,19.682,21.469,25.269,29.414,24.389,37.945,0,0,29.149-26.179,33.268-29.711s14.118-13.529,1.763-25.884S414.5,957.155,410.6,951.663c-6.281-8.823-4.411-15.59-4.411-15.59s-25.565,24.708-31.448,31.182",
    transform: "translate(-368.503 -936.073)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12045",
    "data-name": "Group 12045",
    transform: "translate(1543.399 449.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M374.736,994.654c-5.883,6.471-10.432,16.854,0,28.239,19.682,21.476,25.269,29.415,24.389,37.945,0,0,29.149-26.178,33.268-29.71s14.118-13.529,1.763-25.884S414.5,984.557,410.6,979.065c-6.281-8.827-4.411-15.59-4.411-15.59s-25.565,24.707-31.448,31.178",
    transform: "translate(-368.503 -963.476)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageLeftSideLayer2);
export default __webpack_public_path__ + "static/media/login-page-left-side-layer-2.ec930cbff9b8cf07a41ac07057320423.svg";
export { ForwardRef as ReactComponent };